export const PRIMARY_CARER_PANEL_NAME = 'Xplor_PrimaryCarerPanel'
export const PC_INFO_PILL_NAME = 'Xplor_PC_InfoPill'
export const PC_INFO_PILL_MESSAGE =
  'If you already have an existing account with Xplor, please use the same email and phone number.'

// NOTE: this HTML is rendered verbatim by SurveyJS. It is safe only because the
// message is a hardcoded constant - never interpolate user/API data here.
export const PC_INFO_PILL_HTML = `
  <div class="pc-info-pill">
    <div class="pc-info-pill__body">
      <span aria-hidden="true" class="pc-info-pill__icon">i</span>
      ${PC_INFO_PILL_MESSAGE}
    </div>
  </div>
`.trim()

// Adds an info pill at the top of the Primary Carer panel. Because the pill
// lives inside the panel, it is only rendered on the page that owns it (and it
// inherits the panel's visibility). Skipped in single-page and read-only modes
// where the message adds no value, and a no-op when the panel is absent or the
// pill already exists (idempotent).
export const injectPrimaryCarerInfoPill = (survey, { singlePage, readOnly } = {}) => {
  if (singlePage || readOnly) return survey

  const panel = survey.getPanelByName(PRIMARY_CARER_PANEL_NAME)
  if (!panel || panel.getQuestionByName(PC_INFO_PILL_NAME)) return survey

  const pill = panel.addNewQuestion('html', PC_INFO_PILL_NAME, 0)
  pill.html = PC_INFO_PILL_HTML
  pill.titleLocation = 'hidden'

  return survey
}
